export default "__VITE_ASSET__c61ddbd6__"